import * as React from 'react';
import { useCurrentReviewer } from '../hooks/reviewers/useCurrentReviewer';

type CurrentReviewerContextProps = ReturnType<typeof useCurrentReviewer>;
export const CurrentReviewerContext = React.createContext<CurrentReviewerContextProps | null>(
  null
);

export const useCurrentReviewerContext = () => {
  const context = React.useContext(CurrentReviewerContext);

  if (context === null) {
    throw new Error(
      'useCurrentReviewerContext called outside of a CurrentReviewerProvider context'
    );
  }

  return context;
};

type Props = {
  children: React.ReactNode;
};

export const CurrentReviewerProvider = ({ children }: Props) => {
  const currentReviewer = useCurrentReviewer();

  return (
    <CurrentReviewerContext.Provider value={currentReviewer}>
      {children}
    </CurrentReviewerContext.Provider>
  );
};
